module.exports = __webpack_public_path__ + "static/media/ba.a9dbadd7.svg";